import * as React from 'react'
import { Container, Grid2, TextField, Box } from '@mui/material'
import Navbar from '../../components/setup/Navbar'
import ButtonNormal from '../../BuiltInComponent/ButtonNormal'
import StickyHeadTable from '../../BuiltInComponent/TableWithPagination'
import HeadingTest from '../../BuiltInComponent/HeadingTest'
import { addNewTill, getAllTills } from '../../features/AdminManagement/tillsSlice'
import { useDispatch, useSelector } from 'react-redux'

export default function TIlls() {

    const dispatch = useDispatch()
    const { tills } = useSelector(state => state.tills)
    const [tillsData, settillsData] = React.useState({ tillName: '', tillRemarks: '' })

    React.useEffect(() => {
        dispatch(getAllTills())
    }, [dispatch])

    const handleChange = (e) => {
        settillsData({
            ...tillsData,
            [e.target.name]: e.target.value
        })

    }
    const addTIll = () => {
        dispatch(addNewTill(tillsData)).then(settillsData({ tillName: '', tillRemarks: '' }))
    };

    const tableColumns = [
        { fieldName: 'tillID', cName: 'tillID', textAlign: 'right', width: 80, status: 'en', dType: 'number' },
        { fieldName: 'tillName', cName: 'Till Name', textAlign: 'left', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'tillRemarks', cName: 'Till Remarks', textAlign: 'left', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'Edit', cName: 'Edit', textAlign: 'center', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'Delete', cName: 'Delete', textAlign: 'center', width: 80, status: 'en', dType: 'string' },

    ]
    return (
        <>
            <Navbar />
            <Box sx={{ mb: 2 }}>
                <HeadingTest text='Tills Information' />
            </Box>
            <Container>
                <Grid2 container spacing={2}>
                    <Grid2 size={1.5}></Grid2>
                    <Grid2 size={3}>
                        <TextField id="tillName" label="TIll Name" variant="outlined" fullWidth name="tillName" onChange={handleChange} size='small' value={tillsData.tillName} />
                    </Grid2>
                    <Grid2 size={3}>
                        <TextField id="tillRemarks" label="Till Remarks" variant="outlined" fullWidth name="tillRemarks" onChange={handleChange} size='small' value={tillsData.tillRemarks} />
                    </Grid2>
                    <Grid2 size={3}>
                        <ButtonNormal onClick={addTIll} text='ADD' />
                    </Grid2>
                    <Grid2 size={1.5}></Grid2>
                </Grid2>
                <Box sx={{ mt: 3 }}>
                    <HeadingTest text='Tills List' />
                    <StickyHeadTable tableColumns={tableColumns} tableData={tills} />

                </Box>
            </Container>
        </>
    )
}